import { Navigate } from 'react-router-dom'
import { useFeatureFlagEnabled } from 'posthog-js/react'
import { FeatureFlags } from '@/lib/feature-flags'

interface FeatureFlagRouteProps {
  flag: FeatureFlags
  children: React.ReactNode
  fallbackPath?: string
}

/**
 * A route wrapper that only renders children if the specified feature flag is enabled.
 * Redirects to fallbackPath (default: /insights) if the flag is disabled.
 */
export function FeatureFlagRoute({ 
  flag, 
  children, 
  fallbackPath = '/insights' 
}: FeatureFlagRouteProps) {
  const isEnabled = useFeatureFlagEnabled(flag)
  
  // While loading (undefined), don't render anything to avoid flash
  if (isEnabled === undefined) {
    return null
  }
  
  // If flag is not enabled, redirect to fallback
  if (isEnabled !== true) {
    return <Navigate to={fallbackPath} replace />
  }
  
  return <>{children}</>
}

